import React from 'react'
import Translation from '../global/Translation'
import FiltersV2 from './FiltersV2'
import CircleResultContainer from './results/CircleResultContainer'
import RectangleResultContainer from './rectangleResult/RectangleResultContainer'
import SampleResultContainer from './results/SampleResultContainer'
import * as analytics from '../../analyticsEvents'
import {
    SearchkitManager,
    SearchkitProvider,
    SearchBox,
    Hits,
    ResetFilters,
    BoolShould,
    TermQuery,
    InitialLoader,
    HitsStats,
    BoolMust, TermsQuery
} from 'searchkit'
import { injectIntl } from 'react-intl'
import MoreInfo from '../global/MoreInfo'
import OutletModal from '../global/OutletModal'
import Spinner from '../global/Spinner'
import { LowesInfoText } from './LowesInfoText'
import Alerts from '../alerts/Alerts'
import ResultsV2 from "./results/ResultsV2";
import BannerDekton from '../banners/banner-dekton/BannerDekton'
import BannerRockMaster from "../banners/banner-rockmaster/BannerRockMaster";
import Slider from 'react-slick'
import BannerSilestoneContainer from '../banners/banner-silestone-container/BannerSilestoneContainer';
import BannerHybriq from '../banners/banner-hybriq/BannerHybriq'
import { v4 as uuidv4 } from 'uuid'
import BannerEarthic from '../banners/banner-earthic/BannerEarthic'
import BannerSuma from '../banners/banner-suma/BannerSuma'
import BannerSilestoneXM from '../banners/banner-silestone-xm/BannerSilestoneXM'
import BigBannerRocketV2 from '../banners/banner-rocket/BigBannerRocketV2'
import BannerWorldMallWeek from '../banners/banner-world-mall-week/BannerWorldMallWeek'
import BannerEclosBrand from '../banners/banner-eclos-brand/BannerEclosBrand'
import OnlineVisitBanner from '../online-visit/OnlineVisitBanner'
import { sectionMapToLangId } from '../../helpers'
import { ReactComponent as IconInfo } from '../../assets/img/icons/icon-catalog-info.svg'
import BannerOutletAustralia from '../banners/banner-outlet-australia/BannerOutletAustralia'
import MktoolsOutageMessage from '../mkt-admin/mktools-outage-message/MktoolsOutageMessage'
import BannerFlashPromoSilestoneDekton from '../banners/banner-flash-promo-silestone-dekton/BannerFlashPromoSilestoneDekton'

const customHitStats = (props) => {
    const {hitsCount} = props
    return hitsCount
}

const listRef = {
    value: ''
}

const getSk = (
    token,
    center,
    locale,
    outlet, search, fullView, userType, impersonatedBy, match, priceList, userPriceList, commonParamsAnalytics,
    HQCenterId,
    LowesCenterId,
    sendSearchProduct,
    isPnHq,
    isPnBrazil,
    customerByFabricator,
    isPriorityCustomerForEclos,
    isAustralianCenter,
    canViewEclosBrandInEurope,
    parent,
) => {
    let lang = locale === 'fr-CA' || locale === 'en-CA' ? 'en-US' : locale
    const catalogUri = '/catalog/' + center
    const uri = catalogUri + '?lang=' + lang
    const uri2 = outlet ? uri + '&outlet=true' : uri
    //promo link works fine withouth this since dont knowh what version of react
    // const uri3 = search.indexOf('promo=true') > -1 ? uri2 + '&promo=true' : uri2

    // const uri3 = token ? uri2 + '&authToken=' + token : uri2
    const httpHeaders = token ? { Authorization: 'Bearer ' + token } : {}

    let sk = new SearchkitManager(process.env.REACT_APP_API_HOST + uri2, {
        searchUrlPath: '',
        timeout: 60000,
        httpHeaders
    })

    // Traducciones de cadenas de SearchKit
    sk.translateFunction = key => {
        let translations = {
            'pagination.previous': <Translation id="previous" defaultMessage="Previous" />,
            'pagination.next': <Translation id="next" defaultMessage="Next" />,
            'facets.view_more': <Translation id="view_more" defaultMessage="View more" />,
            'facets.view_less': <Translation id="view_less" defaultMessage="View less" />,
            'facets.view_all': <Translation id="view_all" defaultMessage="View all" />,
            'reset.clear_all': <Translation id="clear_all" defaultMessage="Clear all" />,
            'yes': <Translation id="yes" defaultMessage="Yes" />,
            'no': <Translation id="no" defaultMessage="No" />,
            'outlet_o': <Translation id="outlet_o" defaultMessage="Outlet Basic" />,
            'outlet_v': <Translation id="outlet_v" defaultMessage="Outlet Premium" />,
            'outlet_x': <Translation id="outlet_x" defaultMessage="Outlet Xtreme" />,
            'AND': <Translation id="AND" defaultMessage="Grip +" />,
            'MAT': <Translation id="MAT" defaultMessage="Matte" />,
            'MTT': <Translation id="MTT" defaultMessage="Texturized matte" />,
            'PUL': <Translation id="PUL" defaultMessage="Polished" />,
            'PULMAL': <Translation id="PULMAL" defaultMessage="Polished - meshed" />,
            'PUA': <Translation id="PUA" defaultMessage="Mirage - glase" />,
            'PUC': <Translation id="PUC" defaultMessage="Mirage - century" />,
            'PUN': <Translation id="PUN" defaultMessage="Polished - n-boost" />,
            'MK': <Translation id="mktool" defaultMessage="Marketing Tools" />,
            'SH': <Translation id="showroom" defaultMessage="Showroom" />,
            'WH': <Translation id="warehouse" defaultMessage="Warehouse" />,
            'OPERATIONS': <Translation id="OPERATIONS" defaultMessage="Operations" />,
            'SERVICE': <Translation id="SERVICE" defaultMessage="Services" />,
            '01': <Translation id="SAMPLES" defaultMessage="Samples" />,
            '02': <Translation id="OTHERS" defaultMessage="Others" />,
            '03': <Translation id="MERCHANDISING" defaultMessage="Merchandising" />,
            '04': <Translation id="LITERATURE" defaultMessage="Literature" />,
            '05': <Translation id="TAGS" defaultMessage="Tags" />,
            '06': <Translation id="ANCHORING" defaultMessage="anchoring" />,
            '07': <Translation id="BOXES" defaultMessage="Boxes" />,
            '08': <Translation id="DISPLAYS" defaultMessage="Displays" />,
            '09': <Translation id="BOOKS" defaultMessage="Books" />,
            '10': <Translation id="CABINETS" defaultMessage="Cabinets" />,
            '11': <Translation id="SIGNAGE" defaultMessage="Signage" />,
            '12': <Translation id="TEST_KITS" defaultMessage="Test kits" />,
            '13': <Translation id="WORKWEAR" defaultMessage="Workwear" />,
            '14': <Translation id="EPP" defaultMessage="EPP" />,
            '15': <Translation id="WAREHOUSE_SUPPLIES" defaultMessage="warehouse supplies" />,
            'NEWS': <Translation id="NEWS" defaultMessage="NEWS" />,
            'without_format': <Translation id="without_format" defaultMessage="Without format" />,
            'white': <Translation id="white" defaultMessage="White" />,
            'black': <Translation id="black" defaultMessage="Black" />,
            'grey': <Translation id="grey" defaultMessage="Grey" />,
            'cream': <Translation id="cream" defaultMessage="Cream" />,
            'brown': <Translation id="brown" defaultMessage="Brown" />,
            'other': <Translation id="other" defaultMessage="Other" />,
            'blue': <Translation id="blue" defaultMessage="Blue" />,
            'green': <Translation id="green" defaultMessage="Green" />,
            'red': <Translation id="red" defaultMessage="Red" />,
            'yellow': <Translation id="yellow" defaultMessage="Yellow" />,
            //NEW TYPES
            'BASIN': <Translation id="BASIN" defaultMessage="Bathroom basin" />,
            'VANITY': <Translation id="VANITY" defaultMessage="Washbasin" />,
            'TILE': <Translation id="TILE" defaultMessage="Tile" />,
            'SLAB': <Translation id="SLAB" defaultMessage="Slab" />,
            'SINK': <Translation id="SINK" defaultMessage="Kitchen sink" />,
            'STRAY': <Translation id="STRAY" defaultMessage="Shower tray" />,
            'CLAD': <Translation id="CLAD" defaultMessage="Cladding" />,
            'FLOOR': <Translation id="FLOOR" defaultMessage="Flooring" />,
            'CLAD_FLOOR': <Translation id="CLAD_FLOOR" defaultMessage="Flooring and cladding" />,
            'ELAB': <Translation id="ELAB" defaultMessage="Elaborated" />,
            'PAN': <Translation id="PAN" defaultMessage="Panel" />,
            'PANEL RANURADO': <Translation id="PANEL_RANURADO" defaultMessage="Slatwall panel" />,
            'ACC': <Translation id="ACC" defaultMessage="Accessory" />,
            'C_M': <Translation id="C_M" defaultMessage="Cleaning and maintenance" />,
            'TOOL': <Translation id="TOOL" defaultMessage="Tool" />,
            'AD': <Translation id="AD" defaultMessage="Adhesive" />,
            'SIL': <Translation id="SIL" defaultMessage="Silicone" />,
            'T&R': <Translation id="T&R" defaultMessage="Treatment and repair" />,
            'SINKS': <Translation id="sinks" defaultMessage="Sinks" />,
            'STRAYS': <Translation id="strays" defaultMessage="Strays" />,
        }
        return translations[key]
    }
    sk.addResultsListener(results => {
        parent.setState({ skKey: uuidv4() })
        if(sk.query.getQueryString()){
            sendSearchProduct(sk.query.getQueryString())
        }
        // analytics.sendCatalogImpressions(results.hits.hits, listRef.value, priceList, userPriceList, commonParamsAnalytics)
        analytics.sendCatalogImpressions(results.hits.hits, 'CATALOG', priceList, userPriceList, commonParamsAnalytics, null, center)
    })

    if (isPnHq) {
        const filter = [TermQuery('centerId', '1100')]
        if (!outlet) {
            filter.push(TermsQuery('brand.raw', ['SENSA', 'PREXURY', 'SCALEA']))
        }

        sk.addDefaultQuery(query => {
            return query.addFilter('centerHQ', BoolMust(filter))
        })
    }

    if (isPnBrazil) {
        const filter = [
            TermQuery('centerId', '7500'),
            TermsQuery('brand.raw', ['SENSA', 'PREXURY', 'SCALEA'])
    ];

    sk.addDefaultQuery(query => {
        return query.addFilter('centerBrazil', BoolMust(filter))
    })
    }

    if (center === LowesCenterId) {
        if (match.url.includes('customer-sample'))
            sk.addDefaultQuery(query => {
                return query.addFilter('type', BoolShould([TermQuery('subtypeId.raw', 'CUSTOMER SAMPLES')]))
            })
        else if (match.url.includes('brochures'))
            sk.addDefaultQuery(query => {
                return query.addFilter('type', BoolShould([TermQuery('subtypeId.raw', 'BROCHURES')]))
            })
    }

    if (!(userType === 'ADMIN' || impersonatedBy) && outlet && center === HQCenterId)
        sk.addDefaultQuery(query => {
            return query.addFilter('outletDeviated', BoolShould([TermQuery('outletDeviated.raw', false)]))
        })

    if (customerByFabricator && customerByFabricator.length > 0) {
        sk.addDefaultQuery(query => {
            return query.addQuery({
                bool: {
                    should: [
                        {
                            bool: {
                                must_not: {
                                    exists: {
                                        field: 'exclusiveVendors'
                                    }
                                }
                            }
                        },
                        {
                            terms: {
                                exclusiveVendors: customerByFabricator
                            }
                        }
                    ]
                }
            })
        })
    }

    //Solo mostramos ECLOS si el cliente es prioritario, si se trata de un centro de australia y si es europa o iberia
    if (!isPriorityCustomerForEclos && !isAustralianCenter && !canViewEclosBrandInEurope) {
        sk.addDefaultQuery(query => {
            return query.addFilter(
                'excludeEclos',
                {
                    bool: {
                        must_not: [
                            {
                                term: {
                                    'brand.raw': 'ECLOS'
                                }
                            }
                        ]
                    }
                }
            )
        })
    }

    return sk
}

const ResetSearchBox = ({ hasFilters, resetFilters }) => {
    return (
        <div
            onClick={resetFilters}
            style={{ visibility: hasFilters ? 'visible' : 'hidden' }} 
            className="bt-reset-searchbox"
        />
    )
}

class ResetSearchBoxWrapper extends React.Component {
    componentDidUpdate(prevProps) {
        if (prevProps.hasFilters !== this.props.hasFilters) {
            this.props.onHasFiltersChange(this.props.hasFilters)
        }
    }

    componentDidMount() {
        this.props.onHasFiltersChange(this.props.hasFilters)
    }

    render() {
        return <ResetSearchBox {...this.props} />
    }
}

class Catalog extends React.Component {
    constructor(props) {
        super(props)
        let initState = {
            sk: null,
            showHelp: true,
            showOutletModal: this.props.outlet === 'outlet' && this.props.isAdmin,
            countResult: 0,
            hasFiltersInSearchBox: false
        }
        this.state = initState
    }

    handleHasFitersChanged = (hasFilters) => {
        if (this.state.hasFiltersInSearchBox !== hasFilters ) {
            this.setState({ hasFiltersInSearchBox: hasFilters })
        }
    }
    
    setSk = () => {
        const newSk = getSk(
            this.props.token,
            this.props.center,
            this.props.intl.locale,
            this.props.outlet,
            this.props.location.search,
            this.props.fullView,
            this.props.userType,
            this.props.impersonatedBy,
            this.props.match,
            this.props.priceList,
            this.props.userPriceList,
            this.props.commonParamsAnalytics,
            this.props.HQCenterId,
            this.props.LowesCenterId,
            this.props.sendSearchProduct,
            this.state.pn_hq || this.props.hq,
            this.state.pn_brazil,
            this.props.customerByFabricator,
            this.props.isPriorityCustomerForEclos,
            this.props.isAustralianCenter,
            this.props.canViewEclosBrandInEurope,
            this
        )

        //console.log('currentSearchRequest', newSk.currentSearchRequest)

        this.setState({ sk: newSk }
            // () => {
            // if (this.props.location.search.indexOf('promo=true') > -1 && this.props.isLogged && this.props.center !== 7500) {
            //     this.props.changeCenter(7500)
            // }
            // }
        )
    }
    componentDidMount() {
        this.props.resetOutletFlags()
        // this.props.fetchProductsDiscounts()

        if (this.props.hq) {
            this.setPnHQ(true)
        }

        this.setSk() // en el centro 1060 se pregunta locationf
        if (this.props.isLogged) {
            this.props.fetchProductsFavourite()
        }
        if (this.props.isMkToolsCenter) this.props.fetchShippingAddresses() // en el centro 1060 se pregunta location
        if (this.props.center === this.props.HQCenterId) this.props.fetchDeviatedDescriptions()
        let callbackSalesOrg = null;
        const search = this.props.location.search;
        const salesOrgSearch = '&salesorg=';
        if(search.includes(salesOrgSearch)){
            callbackSalesOrg = search.substring(
              search.indexOf(salesOrgSearch) + salesOrgSearch.length,
              search.indexOf(salesOrgSearch) + salesOrgSearch.length + 4
            );
        }
        if (!this.props.isLogged && this.props.location.search.includes('&lnd=true')) {
            this.props.loginRequired(callbackSalesOrg)
        }
        if (callbackSalesOrg){
            this.props.changeCenterFromSalesOrg(callbackSalesOrg)
        }
    }

    componentDidUpdate(prevProps, prevState) {

        const fromCrossSelling = this.props.location.search && this.props.location.search.includes('cross-selling')
        if (fromCrossSelling) listRef.value = 'crossselling-categoria'
        else {
            let catalogPage = 'CATALOG'
            if (this.props.location.search) {
                catalogPage = catalogPage + ' - busqueda de' + this.props.location.search
            }
            listRef.value = catalogPage
        }

        if (this.props.location !== prevProps.location) {

            //TODO solo hace la llamada cuando cambiar la url
            this.state.sk && this.state.sk.runInitialSearch() //TODO :identificar motivo y si se puede borrar, duplica llamada a elastic see on network
        }

        if (this.props.isLowesCenter && prevProps.location.pathname !== this.props.location.pathname) {
            this.setState({ sk: null }, () => {
                this.setSk()
            })
        }
    }

    filterFavourites = () => {
        this.setState({ sk: null, favouriteFilter: !this.state.favouriteFilter }, () => {
            this.setSk()
        })
    }
    filterDiscounts = () => {
        this.setState({ sk: null, discountsFilter: !this.state.discountFilter }, () => {
            this.setSk()
        })
    }

    setPnHQ = (isPnHQ) => {
        // this.props.redirect(this.props.intl.formatMessage({ id: 'ROUTE_CATALOG' }).replace(':outlet?', ''))
        if (this.props.hq && !isPnHQ) {
            const noHqUrl = this.props.location.pathname.replace('hq', '') + this.props.location.search
            this.props.history.push(noHqUrl)
        }
        this.setState({ pn_hq: isPnHQ })
        this.setState({ sk: null }, () => {
            this.setSk()
        })
        this.props.setIsInOutletSpain(isPnHQ)
    }

    setPnBrazil = (isPnBrazil) => {
        this.setState({ pn_brazil: isPnBrazil })
        this.setState({ sk: null }, () => {
            this.setSk()
        })
        this.props.setIsInOutletBrazil(isPnBrazil)
    }

    canViewWorldMallWeekPromotionFunc = () => {
        const { canViewWorldMallWeekPromotion, selectedCenter, HQCenterId } = this.props

        if (canViewWorldMallWeekPromotion && (selectedCenter != HQCenterId)) {
            return true
        }

        return false
    }

    getDriUsaNormalizedOrderCount() {
        const driUsaOrderLimit = this.props.driUsaOrderLimit || {}
        const orderCount = driUsaOrderLimit.driUsaOrderLimitCount || 0
        const orderLimit = 2

        return Math.min(orderCount, orderLimit)
    }

    getDriUsaRemainingOrders() {
        const normalizedCount = this.getDriUsaNormalizedOrderCount()
        const orderLimit = 2

        return Math.max(orderLimit - normalizedCount, 0)
    }

    render() {
        let LANG_TO_INDEX = {
            da: 'EN',
            de: 'DE',
            'en-US': 'Z2',
            en: 'EN',
            es: 'ES',
            fi: 'EN',
            'fr-CA': 'Z2',
            'en-CA': 'Z2',
            fr: 'FR',
            it: 'IT',
            nl: 'NL',
            no: 'EN',
            pt: 'PT',
            pl: 'EN',
            sv: 'SV',
            tr: 'TR'
        }
        if (this.props.canOnlyViewOutlet && this.props.outlet !== 'outlet') {
            this.props.redirect(this.props.intl.formatMessage({ id: 'ROUTE_CATALOG' }).replace(':outlet?', 'outlet'))
        }
        if (!this.props.canViewOutlet && this.props.outlet === 'outlet') {
            this.props.redirect(this.props.intl.formatMessage({ id: 'ROUTE_CATALOG' }).replace(':outlet?', ''))
        }

        const hitsComponent = this.props.fullView ? (this.props.isLowesCenter ? SampleResultContainer : RectangleResultContainer) : CircleResultContainer
        const hits = <Hits hitsPerPage={23} itemComponent={hitsComponent} className={!this.props.fullView ? 'v2-circle' : ''} />
        const settings = {
            arrows: false,
            swipeToSlide: true,
            dots: false,
            speed: 300,
            autoplaySpeed: 10000,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            autoplay: true,
            variableWidth: false,
        }
        if (!this.state.sk) {
            return null
        }
        let bannerSelector =
            this.props.center === 7110
                ? 'BE-' + this.props.intl.locale.toUpperCase()
                : this.props.center === 7130
                ? 'CH-' + this.props.intl.locale.toUpperCase()
                : this.props.intl.locale.toUpperCase()
        return (
            <React.Fragment>
                    <Slider ref={s => (this.slider = s)} {...settings}>
                        {this.props.canViewEclosBrandInEurope && <BannerFlashPromoSilestoneDekton />}
                        {this.props.canViewSilestoneContainerPromotion && <BannerSilestoneContainer />}
                        {this.props.canViewOutletAustraliaPromotion && <BannerOutletAustralia />}
                        {(this.props.isPriorityCustomerForEclos || this.props.isAustralianCenter) && <BannerEclosBrand isPriaorityCustomer={this.props.isPriorityCustomerForEclos} isAustralianCenter={this.props.isAustralianCenter} className={this.props.canViewRocketPromotion ? 'variable-dimensions' : ''}/>}
                        {this.props.canViewRocketPromotion && <BigBannerRocketV2 market={this.props.canViewRocketPromotion} isOnlyUsaSalesOrg={this.props.isOnlyUsaSalesOrg} />}
                        {this.props.showOnlineVisitBanner && <OnlineVisitBanner className={this.props.canViewRocketPromotion ? 'variable-dimensions' : ''}/>}

                        {/* {this.canViewWorldMallWeekPromotionFunc() && <BannerWorldMallWeek userSalesOrg={this.props.salesOrg} className={this.props.canViewRocketPromotion ? "variable-dimensions" : ""} />} */}
                    </Slider>

                    {this.props.getBlockOrdersFromMktoolsDriUsa && (
                        <MktoolsOutageMessage />
                    )}

                    {(this.props.center && this.props.center == this.props.driUsaCenterId) && this.props.isLogged && (
                        <div className="order-limit-message-container container">
                            <div className="title">
                                <div>
                                    <IconInfo />
                                </div>
                                <div>
                                    <span>
                                        <Translation id="remember_that_you_have_two_monthly_orders_for_marketing_tools" defaultMessage="Remember that you have two monthly orders for marketing tools and showroom products." />
                                    </span>
                                </div>
                            </div>
                            <ul>
                                <li>
                                    <Translation id="orders_placed" defaultMessage="Orders placed" />:{' '}
                                        {this.props.isLoadingDriUsaOrderLimit ? (
                                            <Spinner isLoading={this.props.isLoadingDriUsaOrderLimit} relative small inlineBlock/>
                                        ) : (
                                            <React.Fragment>
                                                {this.getDriUsaNormalizedOrderCount()}
                                            </React.Fragment>
                                        )}
                                </li>
                                <li>
                                    <Translation id="remaining_available_orders" defaultMessage="Remaining available orders" />:{' '}
                                    {this.props.isLoadingDriUsaOrderLimit ? (
                                        <Spinner isLoading={this.props.isLoadingDriUsaOrderLimit} relative small inlineBlock/>
                                    ) : (
                                        <React.Fragment>
                                            {this.getDriUsaRemainingOrders()}
                                        </React.Fragment>
                                    )}
                                </li>
                            </ul>
                            <div className="subtitle">
                                <span>
                                    <Translation id="plan_your_requests_to_make_the_most_of_your_available_orders" defaultMessage="Plan your requests to make the most of your available orders." />
                                </span>
                            </div>
                        </div>
                    )}

                <SearchkitProvider searchkit={this.state.sk}>
                    <section id="section-catalog" className={this.props.outlet ? 'outlet' : ''}>
                        {this.state.showOutletModal && this.props.center === this.props.HQCenterId && !this.props.alreadyClosedOutletModal && (
                            <OutletModal
                                locale={this.props.intl.locale}
                                onClose={() =>
                                    this.setState({ showOutletModal: false }, () => {
                                        this.props.dontShowOutletModalAgain()
                                    })
                                }
                            />
                        )}
                        {this.props.currentLocation && this.props.currentLocation.section && sectionMapToLangId[this.props.currentLocation.section] && (
                            <div className="container">
                                <div className="row">
                                    <h2 className="catalog-title">
                                        <Translation id={sectionMapToLangId[this.props.currentLocation.section]} />
                                    </h2>
                                </div>
                            </div>
                        )}
                        {this.props.isIkeaCenter && (
                            <div className="container">
                                <div className="row">
                                    <h2 className="catalog-title">IKEA</h2>
                                </div>
                            </div>
                        )}
                        {this.props.isLowesCenter && (
                            <div className="container">
                                <div className="row">
                                    <h2 className="catalog-title">
                                        <Translation id="customer_samples" defaultMessage="Customer Samples" />
                                    </h2>
                                </div>
                            </div>
                        )}
                        <div className="search-container">
                            <div className="search-overlay">
                                <div className="container">
                                    <div className="row">
                                        <div className={'w-100'}>
                                            <div className="search-box-container">
                                                <div className="search-box">
                                                    <SearchBox
                                                        searchThrottleTime={1000}
                                                        searchOnChange={true}
                                                        queryFields={[
                                                            'colorId',
                                                            'colorName',
                                                            'description',
                                                            'brand',
                                                            'family',
                                                            'color',
                                                            'productId',
                                                            'productName',
                                                            'subtypeName',
                                                            'format',
                                                            'bigAccountsErpCode',
                                                            `translations.${LANG_TO_INDEX[this.props.intl.locale]}.displayName`,
                                                            `translations.${LANG_TO_INDEX[this.props.intl.locale]}.colorName`,
                                                            `translations.${LANG_TO_INDEX[this.props.intl.locale]}.productName`,
                                                            `translations.${LANG_TO_INDEX[this.props.intl.locale]}.zaddon`,
                                                            `colorFormulations.colorName`,
                                                            'technology'
                                                        ]}
                                                        queryOptions={{ default_operator: 'AND' }}
                                                        // placeholder={this.props.intl.formatMessage({ id: 'search' })}
                                                        placeholder="calacatta pol 2cm jumbo..."
                                                    />
                                                    <ResetFilters
                                                        component={(props) => (
                                                            <ResetSearchBoxWrapper 
                                                                {...props}
                                                                onHasFiltersChange={this.handleHasFitersChanged} />
                                                        )}
                                                        options={{ query: true, filter: false, pagination: true }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.props.maintenanceScheduledText && (
                            <div className="container">
                                <div className="row">
                                    <Alerts status="primary" alert={<div dangerouslySetInnerHTML={{ __html: this.props.maintenanceScheduledText }} />} />
                                </div>
                            </div>
                        )}
                        <div className="filter-and-results-container">
                            <div className="container">
                                <div className={'row f-direction-column filtersv2'}>
                                    <div className={'filter-container'}>
                                        <FiltersV2
                                            {...this.props}
                                            filterFavourites={this.filterFavourites}
                                            filterDiscounts={this.filterDiscounts}
                                            favouriteProducts={this.props.productsIdFavourite}
                                            // userDiscountsProductIds={this.props.promotionsProductIds}
                                            mktools={this.props.center === 5200 || this.props.center === 5000 || this.props.center === 1060}
                                            selectedCenter={this.props.center}
                                            triggerCatalogFilter={this.props.triggerCatalogFilter}
                                        ></FiltersV2>
                                    </div>

                                    <div className={'filter-container'}>
                                        {this.props.isLowesCenter && this.props.match.url.includes('customer-samples') && (
                                            <MoreInfo static>
                                                <LowesInfoText />
                                            </MoreInfo>
                                        )}
                                        {this.props.isLowesCenter && this.props.match.url.includes('brochures') && (
                                            <MoreInfo static>
                                                <h4>
                                                    <Translation id="brochure_re-ordering" defaultMessage="Brochure Re-Ordering" />
                                                </h4>

                                                <ul>
                                                    <li>
                                                        <Translation
                                                            id="To_start_your_order_click_on_the_brochure_that_you_need_to_re-order"
                                                            defaultMessage="To start your order, click on the brochure that you need to re-order"
                                                        />
                                                    </li>
                                                    <li>
                                                        <Translation
                                                            id="Brochures_are_in_packs_of_50_individual_brochures"
                                                            defaultMessage="Brochures are in packs of 50 individual brochures"
                                                        />
                                                    </li>
                                                    <li>
                                                        <Translation
                                                            id="Each_store_is_capped_at_1_pack_of_brochures_for_each_brand_per_month"
                                                            defaultMessage="Each store is capped at 1 pack of brochures for each brand, per month. "
                                                        />
                                                    </li>
                                                    <li>
                                                        <Translation
                                                            id="All_orders_will_be_delivered_within_2-3_weeks_of_order_and_sent_to_the_person_who_placed_the_order"
                                                            defaultMessage="All orders will be delivered within 2-3 weeks of order and sent to the person who placed the order"
                                                        />
                                                    </li>
                                                    <li>
                                                        <Translation id="Shipment_sent_to_the_assigned_store_only" defaultMessage="Shipment sent to the assigned store only" />
                                                    </li>
                                                </ul>
                                            </MoreInfo>
                                        )}
                                        <div>
                                            <ResultsV2
                                                totalResult={<HitsStats component={customHitStats} />}
                                                hits={hits}
                                                token={this.props.token}
                                                outlet={this.props.outlet}
                                                isMkToolsCenter={this.props.isMkToolsCenter}
                                                isLowesCenter={this.props.isLowesCenter}
                                                isIkeaCenter={this.props.isIkeaCenter}
                                                currentLocation={this.props.currentLocation}
                                                statePnHQ={this.state.pn_hq}
                                                setPnHQ={this.setPnHQ}
                                                statePnBrazil={this.state.pn_brazil}
                                                setPnBrazil={this.setPnBrazil}
                                                naturalStoneViewingPermissions={this.props.naturalStoneViewingPermissions}
                                                centerData={this.props.centerData}
                                                skKey={this.state.skKey}
                                                isUsaOrCanada={this.props.isUsaOrCanada}
                                                hasFiltersInSearchBox={this.state.hasFiltersInSearchBox}
                                                isPriorityCustomerForEclos={this.props.isPriorityCustomerForEclos}
                                                selectedCenter={this.props.center}
                                                triggerCatalogSortFilter={this.props.triggerCatalogSortFilter}
                                                canViewNaturalStoneSection={this.props.canViewNaturalStoneSection}
                                            />
                                            {this.props.isUsaOrCanada && (
                                                <React.Fragment>
                                                    <div className="container dekton-banner-desktop">
                                                        <BannerDekton />
                                                    </div>
                                                    <div className="container dekton-banner-squared">
                                                        <BannerDekton squared={true} />
                                                    </div>
                                                </React.Fragment>
                                            )}
                                            
                                            {/* {this.props.canViewEarthicPromotion && (
                                                <BannerEarthic />
                                            )} */}

                                            {this.props.canViewSumaPromotion && (
                                                <BannerSuma />
                                            )}

                                            {this.props.canViewRockMasterPromotion && (
                                                <BannerRockMaster />
                                            )}

                                            {this.props.canViewSilestonePromotionXM && (
                                                <BannerSilestoneXM />
                                            )}
                                            
                                            {/* {this.props.canViewHybriqPromotion && (
                                                <BannerHybriq />
                                            )} */}
                                            
                                        </div>

                                        <InitialLoader component={() => <Spinner isLoading={this.state.sk} relative />} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </SearchkitProvider>
            </React.Fragment>
        )
    }
}

export default injectIntl(Catalog)

